import apiUrl from '../../../constants'
import axios from 'axios'
import moment from 'moment'
import Multiselect from 'vue-multiselect'
import CryptoJS from 'crypto-js';
import printJS from 'print-js'
import Printd from 'printd'
import groupBy from 'lodash/groupBy';

//import {Circle2} from 'vue-loading-spinner'
import Loader from './../shared/loader'
// import VueButtonSpinner from 'vue-button-spinner';
//import vueSpinner from 'vue-spinner'
// import PulseLoader from 'vue-spinner/src/PulseLoader.vue'
// import ClipLoader from 'vue-spinner/src/ClipLoader.vue'
import {
	Validator
} from 'vee-validate'
export default {
	name: 'grc',
	components: {
		Multiselect,
		//  Circle2
		//    VueButtonSpinner
		Loader
	},
	props: [],
	data() {
		return {
			merchantname: '',
			isLoading: false,
			isdrloading: false,
			status: '',
			todayDate: '',
			selected: '',
			DRerrors: '',
			isfound: false,
			isnotfound: false,
			isfoundID: false,
			isnotfoundID: false,
			isExpiryCol: false,
			loginUserEmail: '',
			loading: false,
			loadingText: '<i class="fa fa-spinner fa-spin fa-2x" style="color:#1985ac"></i>',
			rightIcon: '<i class="fa fa-check" style="font-size:25px;color:green" v-if="isfoundID"></i>',
			wrongIcon: '<i class="fa fa-close" style="font-size:25px;color:red" v-if="isnotfoundID"></i>',
			drdata: [],
			mrpDetailsdata: [],
			drdatasingle: [],
			validline: [],
			valideanode: [],
			validpoline: [],
			validpoeancodeline: [],
			isProductidfound: false,
			ismrpfound: false,
			isProductidnotfound: false,
			selectedradiobutton: '',
			invoicematched: false,
			istotalqty: true,
			isredflag: false,
			isgreenflag: false,
			acceptedqterrormsg: "",
			lineitemdata: [],
			linemrpData: [],
			finalmrparr: [],
			listReasonData: [],
			optionalData: [],
			listReasonListData: [],
			editGRCdata: {
				DRNo: '',
				ProductID: '',
				productid: '',
				productdesc: '',
				mrp: '',
				productqty: 0,
				checkedqty: 0,
				totalqty: '',
				acceptedqty: '',
				mfgdate: '',
				shelfLife: '',
				expdate: '',
				rejectedqty: '',
				shortqty: 0,
				extraqty: 0,
				pono: '',
				inwardid: '',
				invoiceno: '',
				warehouseid: 0,
				lotControl: '',
				invoicelineqty: '',
				polineqty: '',
				rejectreasons: '',
				rejectedqty: '',
				rejectedoptionalqty: '',
				optinalreason: '',
			},
			acceptedlotitems: [],
			lotitems: [],
			rejectedlotitems: [],
			totalacclotqty: 0,
			acclotqtyerrormsg: false,
			showaccadditembutton: true,
			addaccitemerror: false,
			accmfgdateerrormsg: '',
			totalrejlotqty: 0,
			rejlotqtyerrormsg: false,
			showrejadditembutton: true,
			addrejitemerror: false,
			accmfgdateerror: true,
			additemerror: false,
			isexprirycontrolled: true,
			expirydateerror: false,
			islotcheked: false,
			polineerror: '',
			linemrperror: false,
			putawaytotalqtyerror: false,
			cannotexceedQtyerror: false,
			istotalquantitymatchederror: false,
			putawayacceptedqtyerror: false,
			cannotexccedacceptedqtyerror: false,
			rejectedqterrormsg: '',
			cannotexccedrejectedqtqtyerror: false,
			arrayofqtyerror: false,
			lotdata: [],
			lotputawayerror: false,
			clientid: '',
			remainqty:'',
			totalrejectcounterrmsg:false,
			//  isLoading: false,
			totalcount:''
		}
	},
	computed: {
		isComplete1() {
			if (this.editGRCdata.totalqty != '' && this.cannotexccedacceptedqtyerror == false && this.rejectedqterrormsg == '' && this.cannotexccedrejectedqtqtyerror == false && this.addaccitemerror == false && this.additemerror == false && this.islotcheked == false && this.polineerror == '' && this.linemrperror == false && this.putawaytotalqtyerror == false && this.cannotexceedQtyerror == false && this.istotalquantitymatchederror == false && this.putawayacceptedqtyerror == false && this.isProductidfound == true && this.ismrpfound == true && this.rejectedqterrormsg == "" && this.arrayofqtyerror == false && this.acceptedqterrormsg == "") {
				return true;
			} else {
				return false;
			}
			if (this.lineitemdata.islotcontrol == 1) {
				if (this.editGRCdata.totalqty != '' && this.isProductidfound && this.ismrpfound && !this.istotalquantitymatchederror && !this.linemrperror && !this.putawayacceptedqtyerror && !this.cannotexccedacceptedqtyerror && !this.putawaytotalqtyerror && !this.cannotexceedQtyerror && !this.lotputawayerror && this.rejectedqterrormsg == "" && !this.cannotexccedrejectedqtqtyerror && !this.arrayofqtyerror && this.acceptedqterrormsg == "" && !this.acclotqtyerrormsg && !this.rejlotqtyerrormsg && !this.additemerror && this.checkallqtymatched()) {
					return true;
				} else {
					return false;
				}
			}
		},
		islotcontrol() {
			if (this.lineitemdata.islotcontrol == 1) {
				return true;
			} else {
				return false;
			}
		},
		isqtymatched() {
			console.log("inqty........")
			if (this.checkallqtymatched()) {
				return true;
			} else {
				return false;
			}
		},

	},
	filters: {
		moment: function(date) {
			return moment(date).format('DD-MM-YYYY');
		}
	},
	mounted() {
		var userdetailEncrypt = window.localStorage.getItem('userdetail')
		var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
		var plaintext = bytes.toString(CryptoJS.enc.Utf8);
		var userdetail = JSON.parse(plaintext);
		this.warehouseid = userdetail.warehouseid;
		this.todayDate = moment().format('DD/MM/YYYY');
		var acclotcount = 1;
		var rejectedlotcount = 1;
	},
	created() {
		this.$validator.extend('totalAcceptQty', {
			getMessage: field => `Total accepted qty cannot be greater than total qty. Please enter a qty less than or equal to total qty`,
			validate: value => {
				if (value) {
					if (parseFloat(value) > parseFloat(this.saveGRCdata.totalqty)) {
						return false;
					} else {
						return true;
					}
				} else {
					return false;
				}
			}
		});
	},
	methods: {
		addqtyLot() {
			this.additemerror = false;
			for (var i = 0; i < this.lotitems.length; i++) {
				if (!this.isNumeric(this.lotitems[i].acceptedlotqty) || !this.isNumeric(this.lotitems[i].rejectedlotqty) || this.lotitems[i].lotno == '') {
					this.additemerror = true;
				}
			}
			if (this.additemerror != true) {
				if (!this.islotcheked) {
					this.$alertify.error(this.$t('grcList.checkAllLots'));
					return false;
				}
				if (this.lotputawayerror) {
					this.$alertify.error(this.$t('grcList.checkAllLots'));
					return false;
				}
				this.lotitems.push({
					lotno: '',
					lotnoerror: false,
					acceptedlotqty: '',
					rejectedlotqty: '',
					lotmfgdate: null,
					lotexpirydate: null,
					shelfLife: '',
					isshelflifematched: false,
					isshelflifenotmatched: false,
					ismovedtorejected: false,
					ischeckbutton: true,
					ismovedbutton: true,
					singlelotputawayerror: false,
					lotrackindone: 0,
					lotitemcheked: true,
					isinvalidlot: false,
				})
				this.islotcheked = false;
			}
			//}
		},
		customLabel(option) {
			return `${option.reasonname}`
		},
		getLocalUserData() {
			var userdetailEncrypt = window.localStorage.getItem('userdetail')
			var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
			var plaintext = bytes.toString(CryptoJS.enc.Utf8);
			var userdetail = JSON.parse(plaintext);
			return userdetail;
		},
		isNumeric: function(n) {
			return !isNaN(parseFloat(n)) && isFinite(n);
		},

		loadRejectReason() {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			this.listReasonListData = []
			this.input = ({
				reasonType: 'reject',
				clientid: this.clientid
			});
			this.isLoading = true;
			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'rejectReasonList',
					'data': this.input,
					headers: {
						'Authorization': 'Bearer ' + myStr

					}
				})
				.then(result => {
					this.isLoading = false;
					this.listReasonListData = result.data.result;

				}, error => {
					this.isLoading = false;
					//console.error(error)
				});

		},
		showSearchDR() {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			this.isfound = true;
			this.isnotfound = false;
			this.editGRCdata.productid = '';
			this.isfoundID = false;
			if (this.editGRCdata.DRNo != '') {
				var drNo = this.editGRCdata.DRNo.trim();
			} else {
				this.resetdrdata();
			}
			if (drNo != '' && drNo.length > 4) {
				this.isdrloading = true;

				this.input = ({
					'invreferenceid': drNo,
					'warehouseid': this.warehouseid,
					'clientid': this.clientid,
					'productid': this.editGRCdata.ProductID ? this.editGRCdata.ProductID : '',
					// 'mrp':this.editGRCdata.mrp ? this.editGRCdata.mrp : '',

				});

				axios({
						method: 'POST',
						'url': apiUrl.api_url + 'getGRCdata',
						'data': this.input,
						headers: {
							'Authorization': 'Bearer ' + myStr
						}
					})
					.then((result) => {
						this.isdrloading = false;
						if (result.data.length > 0) {
							this.drdata = result.data;
							this.validline = [];
							this.valideanode = [];
							this.validpoline = [];
							this.validpoeancodeline = [];
							this.isfound = true;
							this.isnotfound = false;
							this.DRerrors = '';
							for (var i = 0; i < result.data.length; i++) {
								if (result.data[i].poitemid > 0) {
									this.validline.push(result.data[i].productid)
									this.valideanode.push(result.data[i].eancode)
								}
								this.validpoline.push(Number(result.data[i].productid))
								this.validpoeancodeline.push(result.data[i].eancode)
							}
							this.checkProductID();
						} else {
							this.drdata = [];
							this.polineerror = this.$t('grcList.invalidProductErrror');
							this.resetlineitemdata();
							// this.DRerrors = 'Please insert valid DR number';
							this.isProductidfound = false;
							this.isProductidnotfound = true;
							// this.resetdrdata();
						}
					})
			}
		},
		showDetailsRecordsDR() {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			this.isfound = true;
			this.isnotfound = false;
			this.editGRCdata.productid = '';
			this.isfoundID = false;
			this.listReasonData = [];
			this.mrpDetailsdata = [];

			if (this.editGRCdata.DRNo != '') {
				var drNo = this.editGRCdata.DRNo.trim();
			} else {
				this.resetdrdata();
			}
			if (drNo != '' && drNo.length > 4) {
				this.isdrloading = true;

				this.input = ({
					'invreferenceid': drNo,
					'warehouseid': this.warehouseid,
					'clientid': this.clientid,
					'productid': this.editGRCdata.ProductID ? this.editGRCdata.ProductID : '',
					'mrp': this.editGRCdata.mrp ? this.editGRCdata.mrp : '',

				});

				axios({
						method: 'POST',
						'url': apiUrl.api_url + 'getGRCdata',
						'data': this.input,
						headers: {
							'Authorization': 'Bearer ' + myStr
						}
					})
					.then((result) => {

						this.isdrloading = false;
						if (result.data.length > 0) {
							this.mrpDetailsdata = result.data;

							this.checklinemrp();


						} else {
							this.mrpDetailsdata = [];
							this.DRerrors =  this.$t('grcList.validDrError');
							this.isfound = false;
							this.isnotfound = true;
							this.resetdrdata();
						}
					})
			}
		},
		getClientId(e) {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			this.DRerrors = '';
			this.isnotfound = false;
			// this.resetdrdata();
			var code = (e.keyCode || e.which);
			// do nothing if it's an arrow key
			if (code == 37 || code == 38 || code == 39 || code == 40) {
				return;
			}
			if (this.editGRCdata.DRNo != '') {
				var drNo = this.editGRCdata.DRNo.trim();
			} else {
				this.resetdrdata();
			}
			if (drNo != '' && drNo.length > 4) {
				this.isdrloading = true;
				this.input = ({
					'invreferenceid': drNo,
				});

				axios({
						method: 'POST',
						'url': apiUrl.api_url + 'searchDR',
						'data': this.input,
						headers: {
							'Authorization': 'Bearer ' + myStr
						}
					})
					.then((result) => {
						if (result.data.data.clientid) {
							this.clientid = result.data.data.clientid;
							if (result.data.data.multiseller == 1) {
								this.merchantname = result.data.data.merchantname
							}
							this.isfound = true;
							this.isdrloading = false;
							this.isnotfound = false;
							this.DRerrors = false;
							this.isProductidfound = false;
							this.ismrpfound = false;
							this.editGRCdata.ProductID = '';
						} else {
							this.merchantname = '';
							this.isdrloading = false;
							this.drdata = [];
							if (result.data.status == 'closed') {
								this.DRerrors = this.$t('editedjson.closedDRCantCorrected')
								this.isfound = false;
								this.isnotfound = true;
								return false;
					  	}
							this.DRerrors =  this.$t('grcList.validDrError');
							this.isfound = false;
							this.isnotfound = true;
							this.resetdrdata();
						}
					});
			}
		},
		resetdrdata() {
			this.editGRCdata.ProductID = "";
			this.isProductidnotfound = false;
			this.isProductidfound = false;
			this.ismrpfound = false;
			this.polineerror = '';
			this.lineitemdata = "";
			this.linemrpData = "";
			this.finalmrparr = "";
			this.listReasonData = "";
			this.optionalData = "";
			this.editGRCdata.totalqty = "";
			this.editGRCdata.acceptedqty = "";
			this.editGRCdata.rejectedqty = "";
			this.editGRCdata.optinalreason = "";
			this.editGRCdata.rejectreasons = "";
			this.editGRCdata.rejectedoptionalqty = "";
			this.editGRCdata.shortqty = 0;
			this.editGRCdata.mrp = '';
			this.editGRCdata.extraqty = 0;
			this.lotitems = [];
			this.istotalquantitymatchederror = false;
			this.linemrperror = false;
			this.putawayacceptedqtyerror = false;
			this.cannotexccedacceptedqtyerror = false;
			this.putawaytotalqtyerror = false;
			this.cannotexceedQtyerror = false;
			this.rejectedqterrormsg = "";
			this.cannotexccedrejectedqtqtyerror = false;
			this.arrayofqtyerror = false;
			this.acceptedqterrormsg = "";
			this.lotputawayerror = false;
		},
		checkProductID() {
			if (this.isNumeric(this.editGRCdata.ProductID)) {
				var ProductID = Number(this.editGRCdata.ProductID);

			} else {
				var ProductID = this.editGRCdata.ProductID;

			}

			if (ProductID != '') {
				if (this.validpoline.indexOf(ProductID) > -1) {
					if (this.validline.indexOf(ProductID) > -1) {
						this.polineerror = '';
						this.isProductidfound = true;
						this.ismrpfound = false;
						this.isProductidnotfound = false;
						this.lotitems = [];
						this.getlineitemdata(ProductID);
						this.loadRejectReason();
					} else {
						this.polineerror = this.$t('grcList.grnNotDone');
						this.resetlineitemdata();
					}
				} else if (this.validpoeancodeline.length > 0) {
					if (this.valideanode.length > 0) {
						this.polineerror = '';
						this.isProductidfound = true;
						this.ismrpfound = false;
						this.isProductidnotfound = false;
						this.lotitems = [];
						this.getlineitemdata(ProductID);
						this.loadRejectReason();
					} else {
						this.polineerror = this.$t('grcList.grnNotDone');
						this.resetlineitemdata();
					}
				} else {
					this.polineerror = this.$t('grcList.invalidProductErrror');
					this.resetlineitemdata();
				}
			} else {
				this.resetlineitemdata();
				this.polineerror = '';
			}
		},
		getlineitemdata(ProductID) {
			this.linemrpData = [];
			this.finalmrparr = [];
			this.listReasonData = [];
			for (var i = 0; i < this.drdata.length; i++) {
				if (Number(this.drdata[i].productid) == ProductID || this.drdata[i].eancode == ProductID) {
					this.linemrpData.push({
						'mrp': this.drdata[i].mrp
					})
				}
			}
			if (this.linemrpData.length == 1) {
				for (var i = 0; i < this.linemrpData.length; i++) {
					this.editGRCdata.mrp = this.linemrpData[i].mrp;
				}

				this.showDetailsRecordsDR();
			}
		},


		resetlineitemdata() {
			this.isProductidnotfound = true;
			this.isProductidfound = false;
			this.ismrpfound = false;
			this.lineitemdata = "";
			this.linemrpData = "";
			this.finalmrparr = "";
			this.listReasonData = "";
			this.optionalData = "";
			this.editGRCdata.totalqty = "";
			this.editGRCdata.acceptedqty = "";
			this.editGRCdata.rejectedqty = "";
			this.editGRCdata.rejectedoptionalqty = "";
			this.editGRCdata.optinalreason = "";
			this.editGRCdata.rejectreasons = "";
			this.editGRCdata.shortqty = 0;
			this.editGRCdata.mrp = '';
			this.editGRCdata.extraqty = 0;
			this.lotitems = [];
			this.istotalquantitymatchederror = false;
			this.linemrperror = false;
			this.putawayacceptedqtyerror = false;
			this.cannotexccedacceptedqtyerror = false;
			this.putawaytotalqtyerror = false;
			this.cannotexceedQtyerror = false;
			this.rejectedqterrormsg = "";
			this.cannotexccedrejectedqtqtyerror = false;
			this.arrayofqtyerror = false;
			this.acceptedqterrormsg = "";
			this.lotputawayerror = false;
		},

		checklinemrp() {
			var linemrp = Number(this.editGRCdata.mrp);
			this.lineitemdata = "";

			for (var i = 0; i < this.mrpDetailsdata.length; i++) {
				if ((this.mrpDetailsdata[i].productid == this.editGRCdata.ProductID || this.mrpDetailsdata[i].eancode == this.editGRCdata.ProductID) && Number(this.mrpDetailsdata[i].mrp) == linemrp) {
					this.lineitemdata = this.mrpDetailsdata[i];

					if ( this.mrpDetailsdata[i].reason != null ) {//this.mrpDetailsdata[i].rejectedquantity != '' && this.mrpDetailsdata[i].rejectedquantity != null && this.mrpDetailsdata[i].rejectedqty != null

						this.listReasonData.push({
							'id': this.mrpDetailsdata[i].id,
							'reason': this.mrpDetailsdata[i].reason,
							'rejectedquantity': this.mrpDetailsdata[i].rejectedqty,
							'rejecteddate': this.mrpDetailsdata[i].rejecteddate,

						})
					}
					this.editGRCdata.totalqty = this.mrpDetailsdata[i].totalreceivequantity;
					this.editGRCdata.acceptedqty = this.mrpDetailsdata[i].checkedquantity;
					this.editGRCdata.mrp = this.mrpDetailsdata[i].mrp;
					this.editGRCdata.rejectedqty = this.mrpDetailsdata[i].rejectedquantity;
					this.editGRCdata.rejectreasons = this.mrpDetailsdata[i].reason;
					this.editGRCdata.polineqty = this.mrpDetailsdata[i].quantity;
					this.editGRCdata.invoicelineqty = this.mrpDetailsdata[i].invoicequantity;
					this.editGRCdata.extraqty = this.mrpDetailsdata[i].extraquantity;
					this.editGRCdata.shortqty = this.mrpDetailsdata[i].lessquantity;
					if (this.mrpDetailsdata[i].islotcontrol == 1) {
						this.getlineitemlotdata(ProductID, this.mrpDetailsdata[i].productid, this.mrpDetailsdata[i].grcno);
					}
				}
			}

			this.ismrpfound = true;

		},
		checktotalqty() {
			var totalqty = this.editGRCdata.totalqty == '' ? 0 : Number(this.editGRCdata.totalqty);
			var checktotalqty = Number(this.editGRCdata.totalqty);
			if (checktotalqty > Number(this.lineitemdata.totalreceivequantity)) {
				this.cannotexceedQtyerror = true;
			} else {
				this.cannotexceedQtyerror = false;
			}
			if (this.editGRCdata.totalqty != '') {
				this.istotalqty = false;

				if (Number(this.lineitemdata.storeinquantity) > 0) {
					if (totalqty < Number(this.lineitemdata.storeinquantity)) {
						this.putawaytotalqtyerror = true;
					} else {
						this.putawaytotalqtyerror = false;

					}

				} else {
					//console.log("Rack in Not Done")
				}


				if (totalqty < this.lineitemdata.orderedquantity) {
					this.editGRCdata.shortqty = this.lineitemdata.orderedquantity - totalqty;
				} else {
					this.editGRCdata.shortqty = 0;
				}
				if (totalqty > this.lineitemdata.orderedquantity) {
					this.editGRCdata.extraqty = totalqty - this.lineitemdata.orderedquantity;
				} else {
					this.editGRCdata.extraqty = 0;
				}
			} else {
				this.cannotexceedQtyerror = false;
				// this.istotalqty = true;
				// this.editGRCdata.acceptedqty = "";
				// this.editGRCdata.rejectedqty = "";
				// this.editGRCdata.shortqty = 0;
				// this.editGRCdata.extraqty = 0;
			}
			this.istotalquantitymatched();
		},
		checkacceptedqty() {
			this.totalrejectcounterrmsg="";
			var acceptedqty = this.editGRCdata.acceptedqty == '' ? 0 : Number(this.editGRCdata.acceptedqty);
			var checkTotalacceptedqty = Number(this.editGRCdata.acceptedqty);
			if (checkTotalacceptedqty > this.lineitemdata.checkedquantity && checkTotalacceptedqty > Number(this.editGRCdata.totalqty)) {
				this.cannotexccedacceptedqtyerror = true;
			} else {
				this.cannotexccedacceptedqtyerror = false;
			}
			if (this.isNumeric(this.editGRCdata.acceptedqty) && this.editGRCdata.acceptedqty != '') {
				if (acceptedqty > Number(this.editGRCdata.totalqty)) {
					this.acceptedqterrormsg = this.$t('grcList.acceptedQuantityError');

				} else {
					if (Number(this.lineitemdata.storeinquantity) > 0) {
						if (acceptedqty >= Number(this.lineitemdata.storeinquantity)) {
							this.acceptedqterrormsg = "";
							this.editGRCdata.rejectedqty = Number(this.editGRCdata.totalqty) - acceptedqty;
							this.getElementByIdFn('rejectedqty', this.editGRCdata.rejectedqty);
							this.putawayacceptedqtyerror = false;
						} else {
							this.putawayacceptedqtyerror = true;
						}
					} else {
						this.acceptedqterrormsg = "";
						this.editGRCdata.rejectedqty = this.editGRCdata.totalqty - acceptedqty;
						this.getElementByIdFn('rejectedqty', this.editGRCdata.rejectedqty.toString());
					}
				}
			} else {
				this.acceptedqterrormsg = "";
				this.putawayacceptedqtyerror = false;
				this.cannotexccedacceptedqtyerror = false;
				//  this.editGRCdata.rejectedqty = 0;
			}
			this.istotalquantitymatched();
		},
		checkreasondata(obj) {
			var check = 0;
			var optinalqty = 0;
			var updatedrejectedQTY = 0;
			var Finalrejectedqty = 0;
			let datearr = [];
			this.totalrejectcounterrmsg="";



			for (var i = 0; i < this.listReasonData.length; i++) {
				if (this.listReasonData[i].id != obj.id && this.listReasonData[i].rejecteddate == obj.rejecteddate) {
					this.listReasonData[i].rejectedquantity = obj.rejectedquantity
				}
			}

			for (var i = 0; i < this.listReasonData.length; i++) {
				if (datearr.indexOf(this.listReasonData[i].rejecteddate) == -1) {
					if(this.listReasonData[i].rejectedquantity=='' || this.listReasonData[i].rejectedquantity==null)
					this.listReasonData[i].rejectedquantity=0
					check = parseInt(this.listReasonData[i].rejectedquantity)

					updatedrejectedQTY = updatedrejectedQTY + check;
					datearr.push(this.listReasonData[i].rejecteddate)
				}
			}
			if (this.editGRCdata.rejectedoptionalqty != '') {
				optinalqty = parseInt(this.editGRCdata.rejectedoptionalqty)
				updatedrejectedQTY = updatedrejectedQTY + optinalqty;
			}

			this.totalcount=updatedrejectedQTY
			if (updatedrejectedQTY > this.editGRCdata.rejectedqty) {
				this.arrayofqtyerror = true;

				return false;
			} else {
				this.arrayofqtyerror = false;

				return false;

			}
		},
		checkrejectedqty() {
			var rejectedqty = this.editGRCdata.rejectedqty == '' ? 0 : Number(this.editGRCdata.rejectedqty);
			var checktotalrejectedqty = Number(this.editGRCdata.rejectedqty);
			if (checktotalrejectedqty > this.lineitemdata.rejectedquantity && checktotalrejectedqty > this.editGRCdata.totalqty) {
				this.cannotexccedrejectedqtqtyerror = true;
			} else {
				this.cannotexccedrejectedqtqtyerror = false;

			}
			if (this.isNumeric(this.editGRCdata.rejectedqty) && this.editGRCdata.rejectedqty != '') {
				if (rejectedqty > Number(this.editGRCdata.totalqty)) {
					this.rejectedqterrormsg = this.$t('grcList.totalRejectedQtyErr');
				} else {
					this.rejectedqterrormsg = "";
				}
			} else {
				this.rejectedqterrormsg = "";
			}
			this.istotalquantitymatched();
		},
		istotalquantitymatched() {
			if (this.isNumeric(this.editGRCdata.totalqty) && this.isNumeric(this.editGRCdata.acceptedqty) && this.isNumeric(this.editGRCdata.rejectedqty)) {
				if (Number(this.editGRCdata.totalqty) == (Number(this.editGRCdata.acceptedqty) + Number((this.editGRCdata.rejectedqty)))) {
					this.istotalquantitymatchederror = false;
				} else {
					this.istotalquantitymatchederror = true;
				}
			} else {
				this.istotalquantitymatchederror = false;
			}
		},
		getlineitemlotdata(ProductID, productid, grcno) {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			this.input = ({
				'grcno': grcno,
				'warehouseid': this.warehouseid,
				'clientid': this.clientid
			});
			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'getGRCLotdata',
					'data': this.input,
					headers: {
						'Authorization': 'Bearer ' + myStr
					}
				})
				.then((result) => {
					this.lotdata = result.data
					for (var i = 0; i < this.lotdata.length; i++) {
						this.lotitems.push({
							id: this.lotdata[i].id,
							grcno: this.lotdata[i].grcno,
							lotno: this.lotdata[i].lotno,
							acceptedlotqty: this.lotdata[i].acceptedlotqty,
							rejectedlotqty: this.lotdata[i].rejectedlotqty,
							lotmfgdate: this.lotdata[i].manufacturedate,
							lotexpirydate: this.lotdata[i].lotexpirydate,
							shelfLife: '',
							isshelflifematched: true,
							isshelflifenotmatched: false,
							ismovedtorejected: false,
							ischeckbutton: true,
							ismovedbutton: true,
							singlelotputawayerror: false,
							lotnoerror: false,
							lotstoreinqty: this.lotdata[i].lotstoreinqty,
							lotrackindone: this.lotdata[i].lotstoreinqty > 0 ? 1 : 0,
							lotitemcheked: true,
							isinvalidlot: false,
						})
					}
					this.islotcheked = true;
				})
		},
		checkacclotqty(index, acclotqty) {
			if (this.isNumeric(this.lotitems[index].rejectedlotqty)) {
				if (this.checkifemptylots(acclotqty, this.lotitems[index].rejectedlotqty)) {
					this.lotitems[index].isinvalidlot = true;
					this.lotitems[index].lotitemcheked = true
					this.islotcheked = true;
				} else {
					this.lotitems[index].isinvalidlot = false;
					this.lotitems[index].lotitemcheked = false;
				}
			}
			if (acclotqty != '') {
				this.additemerror = false;
			}
			if (this.lotitems[index].lotrackindone != 1) {
				this.lotitems[index].lotitemcheked = false;
				this.lotitems[index].isshelflifematched = false;
			}
			var totallotqty = 0;
			for (var i = 0; i < this.lotitems.length; i++) {
				totallotqty = totallotqty + Number(this.lotitems[i].acceptedlotqty);
			}
			if (totallotqty > this.editGRCdata.acceptedqty) {
				this.acclotqtyerrormsg = true;
			} else {
				this.acclotqtyerrormsg = false;
			}
			if (totallotqty >= this.editGRCdata.acceptedqty) {
				this.showaccadditembutton = false;
			} else {
				this.showaccadditembutton = true;
			}
			if (this.lotitems[index].lotrackindone > 0) {
				if (acclotqty < this.lotitems[index].lotstoreinqty) {
					this.lotitems[index].singlelotputawayerror = true;
					this.lotputawayerror = true;
				} else {
					this.lotputawayerror = false;
					this.lotitems[index].singlelotputawayerror = false;
				}
				this.checkifputawayerror();
			}
		},
		checkifputawayerror() {
			for (var i = 0; i < this.lotitems.length; i++) {
				if (this.lotitems[i].singlelotputawayerror == true) {
					this.lotputawayerror = true;
					return false;
				} else {
					this.lotputawayerror = false;
				}
			}
		},
		checklotno(index, acclotno) {
			if (acclotno != '') {
				this.lotitems[index].isshelflifematched = false;
				this.lotitems[index].lotitemcheked = false;
				this.additemerror = false;
				this.lotitems[index].lotnoerror = false;
			}
		},
		checkrejectedlotqty(index, rejlotqty) {
			if (this.isNumeric(this.lotitems[index].acceptedlotqty)) {
				if (this.checkifemptylots(this.lotitems[index].acceptedlotqty, rejlotqty)) {
					this.lotitems[index].lotitemcheked = true;
					this.lotitems[index].isinvalidlot = true;
					this.islotcheked = true;
				} else {
					this.lotitems[index].isinvalidlot = false;
					this.lotitems[index].lotitemcheked = false;
				}
			}
			if (rejlotqty != '') {
				this.additemerror = false;
			}
			if (this.lotitems[index].lotrackindone != 1) {
				this.lotitems[index].lotitemcheked = false;
				this.lotitems[index].isshelflifematched = false;
			}
			var totallotqty = 0;
			for (var i = 0; i < this.lotitems.length; i++) {
				totallotqty = totallotqty + Number(this.lotitems[i].rejectedlotqty);
			}
			if (totallotqty > this.editGRCdata.rejectedqty) {
				this.rejlotqtyerrormsg = true;
			} else {
				this.rejlotqtyerrormsg = false;
			}
			if (totallotqty >= this.editGRCdata.rejectedqty) {
				this.showrejadditembutton = false;
			} else {
				this.showrejadditembutton = true;
			}
		},
		checkrejectedlotno(index, rejlotno) {
			if (rejlotno != '') {
				this.addrejitemerror = false;
			}
		},
		checkaccmfgdate(index, mfgdate) {
			if (mfgdate !== '' && mfgdate !== null) {
				var sd = new Date(mfgdate);
				var ed = new Date();
				if (Date.parse(sd) > Date.parse(ed)) {
					this.accmfgdateerror = true;
					this.accmfgdateerrormsg = this.$t('stockCorrectionReport.manufactureDateErr');
					this.lotitems[index].lotmfgdate = null;
				} else {
					this.islotcheked = false;
					this.lotitems[index].isshelflifematched = false;
					this.lotitems[index].lotitemcheked = false;
					this.accmfgdateerror = false;
					this.accmfgdateerrormsg = "";
				}
			}
		},
		shelflifeChanged: function(index) {
			var selectedInd = index;
			var shelflife = this.lotitems[selectedInd].shelflife;
			var ltdate = this.lotitems[selectedInd].lotmfgdate
			if ((shelflife != '' && shelflife != null && shelflife != 'undefined') && (ltdate != '' && ltdate != null)) {
				this.islotcheked = false;
				var mfg = this.lotitems[selectedInd].lotmfgdate;
				var exprirydate = new Date(this.lotitems[selectedInd].lotmfgdate);
				var shelflifeduration = shelflife;
				exprirydate.setMonth(exprirydate.getMonth() + Number(shelflifeduration));
				var newexpirydate = new Date(exprirydate);
				this.lotitems[selectedInd].lotexpirydate = this.getdate1(exprirydate);
				this.lotitems[index].isshelflifematched = false;
				this.lotitems[index].lotitemcheked = false;
				this.lotitems[index].isshelflifenotmatched = false;
			} else {
				return false;
			}
		},
		checkexpirydate(index) {
			this.lotitems[index].isshelflifematched = false;
			this.lotitems[index].lotitemcheked = false;
			this.islotcheked = false;
			this.lotitems[index].ismovedbutton = true;
			this.lotitems[index].isshelflifenotmatched = false;
			this.lotitems[index].isshelflifematched = false;
		},
		checklot(index) {
			if (this.lotitems[index].lotno != '') {
				this.checkshelflife(index);
			} else {
				this.lotitems[index].lotnoerror = true;
				this.$alertify.error(this.$t('grcList.fillAllLotDetails'))
			}
		},
		movetorejected(index) {
			this.editGRCdata.rejectedqty = Number(this.editGRCdata.rejectedqty) + Number(this.lotitems[index].acceptedlotqty);
			this.getElementByIdFn('rejectedqty', this.editGRCdata.rejectedqty.toString());
			this.editGRCdata.acceptedqty = Number(this.editGRCdata.acceptedqty) - Number(this.lotitems[index].acceptedlotqty);
			this.getElementByIdFn('acceptedqty', this.editGRCdata.acceptedqty.toString());
			this.lotitems[index].rejectedlotqty = Number(this.lotitems[index].rejectedlotqty) + Number(this.lotitems[index].acceptedlotqty);
			this.lotitems[index].acceptedlotqty = 0;
			this.lotitems[index].ismovedtorejected = true;
			this.lotitems[index].ischeckbutton = false;
			this.lotitems[index].isshelflifenotmatched = false;
			this.lotitems[index].ismovedbutton = false;
		},
		checkshelflife: function(index) {
			if (this.lotitems[index].lotexpirydate != '' && this.lotitems[index].lotexpirydate != null && this.isNumeric(this.lotitems[index].acceptedlotqty) && this.isNumeric(this.lotitems[index].rejectedlotqty) && !this.lotputawayerror) {
				var newexpirydate = new Date(this.lotitems[index].lotexpirydate);
				var currentdate = new Date();
				var lotexpirycap = this.monthDiff(currentdate, newexpirydate);
				this.islotcheked = true;
				this.lotitems[index].lotitemcheked = true;
				if (lotexpirycap < 3) {
					this.lotitems[index].isshelflifenotmatched = true;
					this.lotitems[index].isshelflifematched = false;
				} else {
					this.lotitems[index].isshelflifematched = true;
					this.lotitems[index].isshelflifenotmatched = false;
				}
			} else {
				this.$alertify.error(this.$t('grcList.fillLotRequiredFields'));
			}
		},
		clearlot() {
			this.editGRCdata.acceptedqty = '';
			this.editGRCdata.rejectedqty = '';
			this.editGRCdata.rejectreasons = '';
			this.getElementByIdFn('acceptedqty', '');
			this.getElementByIdFn('rejectedqty', '');
			this.lotitems = [];
			this.lotitems.push({
				lotno: '',
				lotnoerror: false,
				acceptedlotqty: '',
				rejectedlotqty: '',
				lotmfgdate: null,
				lotexpirydate: null,
				shelfLife: '',
				isshelflifematched: false,
				isshelflifenotmatched: false,
				ismovedtorejected: false,
				ischeckbutton: true,
				ismovedbutton: true,
				isinvalidlot: false,
			})
		},
		updateGRC(scope) {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			this.$validator.validateAll(scope).then((result) => {
				if (result) {
					var qtylotitems = [];
					var newqtylotitems = [];
					this.optionalData = [];
					var grcStatus = "done";
					var userdetail = this.getLocalUserData();
					if (userdetail) {
						this.loginUserEmail = userdetail.email;
					}
					if (this.editGRCdata.optinalreason != '' && this.editGRCdata.rejectedoptionalqty) {
						this.optionalData.push({
							'reason': this.editGRCdata.optinalreason,
							'rejectedqty': this.editGRCdata.rejectedoptionalqty
						})
					}
					for (var i = 0; i < this.lotitems.length; i++) {
						if (!this.lotitems[i].isinvalidlot) {
							if (this.lotitems[i].lotitemcheked == false) {
								this.$alertify.error(this.$t('grcList.checkAllLots'));
								return false
							}

							if (this.lotitems[i].isshelflifenotmatched == true) {
								this.$alertify.error(this.$t('grcList.moveLotToRejected'));
								return false
							}
						}
						if (this.lotitems[i].acceptedlotqty != '' || this.lotitems[i].rejectedlotqty != '' || this.lotitems[i].lotno != '') {

							if (this.lotitems[i].id > 0) {
								qtylotitems.push({
									"id": this.lotitems[i].id,
									"lotno": this.lotitems[i].lotno,
									"rejectedlotqty": Number(this.lotitems[i].rejectedlotqty),
									"acceptedlotqty": Number(this.lotitems[i].acceptedlotqty),
									"manufacturedate": this.lotitems[i].lotmfgdate,
									"lotexpirydate": this.lotitems[i].lotexpirydate
								});
							} else {
								if (!this.lotitems[i].isinvalidlot) {
									newqtylotitems.push({
										"lotno": this.lotitems[i].lotno,
										"rejectedlotqty": Number(this.lotitems[i].rejectedlotqty),
										"acceptedlotqty": Number(this.lotitems[i].acceptedlotqty),
										"manufacturedate": this.lotitems[i].lotmfgdate,
										"lotexpirydate": this.lotitems[i].lotexpirydate
									})
								}
							}
						}
					}
					this.input = ({
						pono: this.lineitemdata.pono,
						grcno: this.lineitemdata.grcno,
						poitemid: Number(this.lineitemdata.poitemid),
						invreferenceid: this.lineitemdata.invreferenceid,
						inwardid: this.lineitemdata.inwardid,
						invoiceno: this.lineitemdata.invoiceno,
						productid: this.lineitemdata.productid,
						clientproductid: this.lineitemdata.clientproductid,
						checkedquantity: Number(this.editGRCdata.acceptedqty),
						totalreceivequantity: Number(this.editGRCdata.totalqty), // recive quantity
						rejectedquantity: Number(this.editGRCdata.rejectedqty),
						extraquantity: Number(this.editGRCdata.extraqty),
						lessquantity: Number(this.editGRCdata.shortqty),
						invoicequantity: Number(this.editGRCdata.invoicelineqty),
						// polineqty:Number(this.editGRCdata.polineqty),
						mrp: this.linemrpData.mrp,
						reason: this.listReasonData,
						lastmodifiedby: this.loginUserEmail,
						warehouseid: this.lineitemdata.warehouseid,
						qtylotitems: qtylotitems,
						newqtylotitems: newqtylotitems,
						optionalData: this.optionalData,
						clientid: this.clientid
					});
					this.isLoading = true;
					axios({
							method: 'POST',
							'url': apiUrl.api_url + 'UpdateLineitemGRC',
							'data': this.input,
							headers: {
								'Authorization': 'Bearer ' + myStr
							}
						})
						.then((response) => {
							this.isLoading = false;
							if (response.data.errorCode == 0) {
								this.$alertify.success(response.data.msg);
							} else {
								this.$alertify.error(response.data.msg);
							}
							// this.$validator.reset(scope);
							this.resetScope();
						})
						.catch((httpException) => {
							this.isLoading = false;
							this.$alertify.error(this.$t('grcList.exceptionErr'));
						});
				} else {
					return false;
				}
			});
		},
		checkallqtymatched() {
			var totalacceptedqty = 0;
			var totalrejectedqty = 0;
			for (var i = 0; i < this.lotitems.length; i++) {
				totalacceptedqty = totalacceptedqty + Number(this.lotitems[i].acceptedlotqty);
				totalrejectedqty = totalrejectedqty + Number(this.lotitems[i].rejectedlotqty);
			} console.log(totalacceptedqty)
			if (totalacceptedqty == Number(this.editGRCdata.acceptedqty) && totalrejectedqty == Number(this.editGRCdata.rejectedqty)) {
				return true;
			} else {
				return false;
			}
		},
		totalrejectedcount(){
			if(this.clientid){
				if(this.totalcount=="" || this.totalcount==null){
				var totalrejectedqty = 0;
				for (var i = 0; i < this.listReasonData.length; i++) {
					totalrejectedqty += parseInt(this.listReasonData[i].rejectedquantity)
				}
				this.totalcount=totalrejectedqty
			}
				if (this.totalcount == this.editGRCdata.rejectedqty){
					this.totalrejectcounterrmsg = '';
					this.updateGRC('editGRCForm');
					 }	 else {
						 this.remainqty = this.editGRCdata.rejectedqty - this.totalcount

						//  this.totalrejectcounterrmsg = true;
						this.totalrejectcounterrmsg = "Total Rejected Quantity And Rejected Reason Quantity should be equal "
						if(this.remainqty<0){
							console.log("heretoo")
						this.totalrejectcounterrmsg+= "remove "+ Math.abs(this.remainqty) +" more"}
						else if(this.remainqty>0){
							this.totalrejectcounterrmsg+= "add "+ this.remainqty +" more"}


					}
			}		
			},
		clearsinglelot(index) {
			this.lotitems[index].lotno = '';
			this.lotitems[index].lotnoerror = false;
			this.lotitems[index].acceptedlotqty = '';
			this.lotitems[index].rejectedlotqty = '';
			this.lotitems[index].lotmfgdate = null;
			this.lotitems[index].lotexpirydate = null;
			this.lotitems[index].shelfLife = '';
			this.lotitems[index].isshelflifematched = false;
			this.lotitems[index].isshelflifenotmatched = false;
			this.lotitems[index].ismovedtorejected = false;
			this.lotitems[index].ischeckbutton = true;
			this.lotitems[index].ismovedbutton = true;
			this.lotitems[index].singlelotputawayerror = false;
			this.lotitems[index].lotrackindone = 0;
			this.lotitems[index].lotitemcheked = true;
			this.lotitems[index].isinvalidlot = false;
		},
		resetScope() {
			var self = this;

			self.isProductidfound = false;
			self.ismrpfound = false;
			self.isProductidnotfound = false;
			self.selectedradiobutton = '';
			self.invoicematched = false;
			self.istotalqty = true;
			self.acceptedqterrormsg = "";

			self.editGRCdata.ProductID = '';
			self.editGRCdata.mrp = '';
			self.linemrpData = [];
			self.acceptedlotitems = [];
			self.rejectedlotitems = [];
			self.lotitems = [];
			self.totalacclotqty = 0;
			self.acclotqtyerrorms = false;
			self.showaccadditembutton = true;
			self.addaccitemerror = false;
			self.additemerror = false;
			self.isexprirycontrolled = false;
			self.islotcheked = false;
			self.polineerror = '';
			self.linemrperror = false;
			self.putawaytotalqtyerror = false;
			self.cannotexceedQtyerror = false;
			self.istotalquantitymatchederror = false;
			self.putawayacceptedqtyerror = false;
			self.cannotexccedacceptedqtyerror = false;
			self.rejectedqterrormsg = '';
			self.cannotexccedrejectedqtqtyerror = false;
			self.arrayofqtyerror = false;
			self.lotdata = [];
			// Object.keys(this.editGRCdata).forEach(function(key, index) {
			//   self.editGRCdata[key] = '';
			//   if (key == 'productqty' || key == "checkedqty" || key == "shortqty" || key == "extraqty") {
			//     self.editGRCdata[key] = 0;
			//   }
			// });
			self.listReasonData = [];
			self.lotputawayerror = false;
			self.editGRCdata.optinalreason = '';
			self.editGRCdata.rejectedoptionalqty = "";
			self.isfound = true;

			// this.getClientId();
			// this.showSearchDR();
		},
		resetForm() {

			this.merchantname = '';
			var self = this;
			self.isProductidfound = false;
			self.ismrpfound = false;
			self.isProductidnotfound = false;
			self.selectedradiobutton = '';
			self.invoicematched = false;
			self.istotalqty = true;
			self.acceptedqterrormsg = "";
			self.lineitemdata = [];
			Object.keys(this.editGRCdata).forEach(function(key, index) {
				self.editGRCdata[key] = '';
				if (key == 'productqty' || key == "checkedqty" || key == "shortqty" || key == "extraqty") {
					self.editGRCdata[key] = 0;
				}
			});
			self.editGRCdata.ProductID = '';
			self.editGRCdata.DRNo = '';
			// this.getElementByIdFn('lino', '');
			// this.getElementByIdFn('DRNo', '');
			self.acceptedlotitems = [];
			self.rejectedlotitems = [];
			self.lotitems = [];
			self.totalacclotqty = 0;
			self.acclotqtyerrorms = false;
			self.showaccadditembutton = true;
			self.addaccitemerror = false;
			self.additemerror = false;
			self.isexprirycontrolled = false;
			self.islotcheked = false;
			self.polineerror = '';
			self.linemrperror = false;
			self.putawaytotalqtyerror = false;
			self.cannotexceedQtyerror = false;
			self.istotalquantitymatchederror = false;
			self.putawayacceptedqtyerror = false;
			self.cannotexccedacceptedqtyerror = false;
			self.rejectedqterrormsg = '';
			self.cannotexccedrejectedqtqtyerror = false;
			self.arrayofqtyerror = false;
			self.lotdata = [];
			self.lotputawayerror = false;
			self.isfound = false;
			self.totalrejectcounterrmsg = false;
			//self.totalrejectedcount()
		},
		monthDiff(d1, d2) {
			var months;
			months = (d2.getFullYear() - d1.getFullYear()) * 12;
			months -= d1.getMonth() + 1;
			months += d2.getMonth();
			return months <= 0 ? 0 : months;
		},
		getScore(val) {
			return parseFloat(val).toFixed(2);
		},
		getdate1(date) {
			var today = new Date(date);
			var dd = today.getDate();
			var mm = today.getMonth() + 1; //January is 0!
			var yyyy = today.getFullYear();
			if (dd < 10) {
				dd = '0' + dd;
			}
			if (mm < 10) {
				mm = '0' + mm;
			}
			var today = yyyy + '-' + mm + '-' + dd;
			return today;
		},
		getElementByIdFn(elmId, val) {
			document.getElementById(elmId).value = val;
		},
		checkifemptylots(acclotqty, rejlotqty) {
			if (Number(acclotqty) == 0 && Number(rejlotqty) == 0) {
				this.$alertify.error(this.$t('grcList.invalidLot'));
				return true;
			} else {
				return false;
			}
		},
	}
}



// WEBPACK FOOTER //
// ./src/views/components/GRCcorrection/grccorrection.component.js